<template>
    <div class="user-points">
        <div class="user-points-title">
            <img src="@/assets/images/icon_zhuangshi@2x.png" alt="">
            <span>积分明细</span>
        </div>
        <div class="user-points-bg">
            <div class="user-points-lists">
            <div class="user-point-item user-point-item-header">
                <div>积分方式</div>
                <div>时间</div>
                <div>积分</div>
            </div>
                <div
                    v-for="(item, index) in form.formResult.list"
                    :key="index"
                    class="user-point-item">
                    <div>{{ item.content }}</div>
                    <div>{{ item.createTime}}</div>
                    <div class="pints">{{ item.pints > 0 ? '+' + item.pints : item.pints }}</div>
                </div>
            </div>
            <pagination :form="form" @request-form-list="pointListPage"></pagination>
        </div>
    </div>
</template>
<script>
import Pagination from '../../components/pagination/index'

export default {
    name: 'userPoints',
    components: { Pagination },
    data() {
        return {
            form: {
                formResult: { currentPage: 1, total: 0, list: [] },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            }
        }
    },
    activated() {
        this.pointListPage()
    },
    methods: {
        pointListPage() {
            this.$api.user.points.list({formData: {}, pageData: this.form.pageData}).then(res => {
                this.form.formResult = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';

.user-points {
    .user-points-title {
        font-size: .18rem;
        color: $font__color_000;
        img {
            width: .26rem;
            margin-right: .1rem;
            vertical-align: middle;
        }
    }
    .user-points-bg {
        background: $white_bg_color;
        border: 1px solid $border_color_eb;
        margin: .1rem 0 .2rem;
    }
    .user-points-lists {
        padding: 0 .2rem;
    }
    .user-point-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: .5rem;
        font-size: .15rem;
        border-bottom: 1px solid $grey_border_color_e0;
        padding: 0 .2rem;
        color: $font_color;
        >div {
            width: 33.333%;
          min-width: 1rem;
          text-align: center;
          &:nth-child(1) {
              text-align: left;
          }
          &:nth-child(3) {
              text-align: right;
          }
        }
        &:last-child {
            border: 0;
        }
        .pints {
            color: $font_color_A60;
        }
    }
    .user-point-item-header {
      line-height: .52rem;
      color: $font_color_51b;
      font-weight: 500;
    }

}
</style>
